<style src="./CreateCampaign.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <form @submit.prevent="sendCampaign">
      <div class="form-group">
        <label>Titulo da campanha</label>
        <input
          type="text"
          class="form-control"
          v-model="form.title"
          placeholder="Minha campanha"
        />
      </div>
      <div class="form-group">
        <label>Url do banner</label>
        <input
          type="text"
          class="form-control"
          v-model="form.bannerUrl"
          placeholder="https://google.com"
        />
      </div>
      <div class="form-group">
        <label>Validade da campanha</label>
        <input
          type="date"
          class="form-control"
          v-model="form.validity"
          placeholder="Validade da campanha"
        />
      </div>

      <div v-bind="getRootProps()" class="customdropzone" id="customdropzone">
        <input v-bind="getInputProps()" />
        <p v-if="isDragActive">Solte os arquivos aqui...</p>
        <p v-else><i class="fa fa-cloud-upload"></i> Upload</p>
        <div v-if="droppedFiles.length > 0" class="dropzone-file-list">
          <span>{{ droppedFiles[0].name }}</span>
          <i class="fa fa-times" @click.stop="droppedFiles = []"></i>
        </div>
      </div>

      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-lg btn-primary "
          @click="sendCampaign"
        >
          <i class="fa fa-plus"></i>
          Criar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useDropzone } from 'vue3-dropzone';
import { toast } from '@/plugins/toast';
export default {
  name: "CreateCampaign",
  setup() {
    const droppedFiles = ref([]);
    function onDrop(acceptedFiles) {
      droppedFiles.value = acceptedFiles.slice(0, 1);
    }
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      multiple: false,
      maxFiles: 1,
    });
    return { getRootProps, getInputProps, isDragActive, droppedFiles };
  },
  data: () => ({
    form: {
      title: "",
      bannerUrl: "",
      validity: "",
    },
  }),
  methods: {
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async sendCampaign() {
      const { title, bannerUrl, validity } = this.form;
      if (title.trim().length === 0 || bannerUrl.trim().length === 0) {
        return;
      }
      if (this.droppedFiles.length === 0) {
        return;
      }
      const f = this.droppedFiles[0];
      const dataURL = await this.readFileAsync(f);
      const image = { base64: dataURL, fileName: f.name };
      try {
        await this.$store.dispatch("CAMPAIGN/CreateCampaign", {
          title,
          bannerUrl,
          validity,
          image,
        });
        toast.success("Campanha criada.");
        this.droppedFiles = [];
      } catch (error) {
        toast.error("Não foi possível criar campanha");
      }
    },
  },
};
</script>
